export default __webpack_public_path__ + "static/media/about.e5b77fe9.jpg";